import React from 'react';
import { CheckIcon } from 'lucide-react';
export function TeamResults() {
  return <section className="w-full bg-[#0a0a0a] py-20 sm:py-24 px-4 sm:px-6 lg:px-8 border-t border-[#1a1a1a]" data-id="element-356">
      <div className="max-w-7xl mx-auto" data-id="element-357">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-358">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-4" data-id="element-359">
            Resultados Reales <span className="text-[#C9A84C]" data-id="element-360">del Equipo</span>
          </h2>
          <div className="section-divider mt-6" data-id="element-361" />
        </div>

        {/* Cards Grid — 2 cards centered */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 xl:gap-12 max-w-5xl mx-auto" data-id="element-362">
          {/* Card 1: Ruimán */}
          <div className="bg-[#1a1a1a] border border-[#C9A84C]/20 flex flex-col overflow-hidden hover:border-[#C9A84C]/50 transition-colors duration-300 shadow-lg shadow-black/50 group" data-id="element-363">
            <div className="w-full overflow-hidden bg-black aspect-[16/10]" data-id="element-364">
              <img src="https://cdn.magicpatterns.com/uploads/hcRXKL9kcyYQbPYBr1pukN/Ruiman_.jpg" alt="Ruimán — antes y después" className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700" data-id="element-365" />
            </div>
            <div className="p-6 sm:p-8 flex-1 flex flex-col" data-id="element-366">
              <h3 className="font-heading font-bold text-white uppercase text-xl tracking-wide mb-3" data-id="element-367">
                De empezar desde pequeño
              </h3>
              <p className="font-body text-gray-400 text-sm leading-relaxed mb-6 flex-1" data-id="element-368">
                Ruimán empezó a entrenar desde niño. Con disciplina y constancia
                hoy compite y mantiene un récord invicto dentro del equipo.
              </p>
              <ul className="space-y-3" data-id="element-369">
                <li className="flex items-start gap-3" data-id="element-370">
                  <CheckIcon size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-371" />
                  <span className="font-body text-gray-300 text-sm" data-id="element-372">
                    Empezó desde pequeño
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-373">
                  <CheckIcon size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-374" />
                  <span className="font-body text-gray-300 text-sm" data-id="element-375">
                    Formación deportiva real
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-376">
                  <CheckIcon size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-377" />
                  <span className="font-body text-gray-300 text-sm" data-id="element-378">
                    Actualmente invicto
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Card 2: Transformación */}
          <div className="bg-[#1a1a1a] border border-[#C9A84C]/20 flex flex-col overflow-hidden hover:border-[#C9A84C]/50 transition-colors duration-300 shadow-lg shadow-black/50 group" data-id="element-379">
            <div className="w-full overflow-hidden bg-black aspect-[16/10]" data-id="element-380">
              <img src="https://cdn.magicpatterns.com/uploads/f6WcgiGUAidfTXDRYPFMR7/chica_.png" alt="Transformación física — antes y después" className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700" data-id="element-381" />
            </div>
            <div className="p-6 sm:p-8 flex-1 flex flex-col" data-id="element-382">
              <h3 className="font-heading font-bold text-white uppercase text-xl tracking-wide mb-3" data-id="element-383">
                Transformación Física y Mental
              </h3>
              <p className="font-body text-gray-400 text-sm leading-relaxed mb-6 flex-1" data-id="element-384">
                El entrenamiento no solo cambia el físico, también desarrolla
                disciplina, seguridad y confianza.
              </p>
              <ul className="space-y-3" data-id="element-385">
                <li className="flex items-start gap-3" data-id="element-386">
                  <CheckIcon size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-387" />
                  <span className="font-body text-gray-300 text-sm" data-id="element-388">
                    Mejora física
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-389">
                  <CheckIcon size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-390" />
                  <span className="font-body text-gray-300 text-sm" data-id="element-391">
                    Más energía
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-392">
                  <CheckIcon size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" data-id="element-393" />
                  <span className="font-body text-gray-300 text-sm" data-id="element-394">
                    Más confianza
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}